// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".video-object{position:relative;display:block;width:100%;padding:0;overflow:hidden}.video-object:before{content:\"\";display:block;padding-top:56.25%}.video-object .embed-responsive-item,.video-object embed,.video-object iframe,.video-object object,.video-object video{position:absolute;top:0;bottom:0;left:0;width:100%;height:100%;border:0}\n", ""]);
// Exports
module.exports = exports;
